import { LocationApi } from '../api/apicollection';

export default function ConfirmationViewModel() {
    this.location = ko.observable();

    this.Load = () => {
        LocationApi.getLocationData().then(data => {
            this.location(data.data);
        });
    };
    this.Load();

    this.formatPhone = (number) => {
        let cleaned = `${number}`.replace(/\D/g, '');           // Replace non numeric characters with ''.
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);   // Creates groupings of 3, 3, & 4.
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return number;
    };

    return this;
}